import { render } from "./App.vue?vue&type=template&id=179c857c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=179c857c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179c857c"]])

export default __exports__